import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_TxPlanReview = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_TxPlanReview' className='file-pdf-document'>
            <div className='file-template'>
            <p className='w-750'>
                    <span className='eleHeader'>Services:</span>
                    <td className='w-375'><input type='radio' id='rb_10_1' name='rb_10' className='add-only' value='1' /> H2019 HR Individual & Family Therapy</td>
                    <td className='w-375'><input type='radio' id='rb_10_2' name='rb_10' className='add-only' value='2' /> H2019 HO TBOS</td>
                </p>
                <p className='w-750'>
                    <td className='w-375'><input type='radio' id='rb_10_3' name='rb_10' className='add-only' value='3' /> H2017 Psychosocial Rehabilitation</td>
                    <td className='w-375'><input type='radio' id='rb_10_4' name='rb_10' className='add-only' value='4' /> H2019 HQ Group Therapy</td>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Select One</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Tx Plan Start Date</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Tx Plan Expiration Date</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rb_1_1' name='rb_1' className='add-only' value='1' />
                            Tx Plan
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txt_2' name='txt_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txt_3' name='txt_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rb_1_2' name='rb_1' className='add-only' value='2' />
                            Tx Plan Review
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txt_4' name='txt_4' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txt_5' name='txt_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rb_1_3' name='rb_1' className='add-only' value='3' />
                            Tx Plan Addedum
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txt_6' name='txt_6' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txt_7' name='txt_7' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Service Provider Name</span>
                            <input type='text' id='txt_8' name='txt_8' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Service Start Date</span>
                            <input type='date' id='txt_9' name='txt_9' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Client Problem #1</span>
                    <textarea id='txt_15' name='txt_15' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rb_16_1' name='rb_16' className='add-only' value='1' /> New
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_16_2' name='rb_16' className='add-only' value='2' /> Fully Met
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_16_3' name='rb_16' className='add-only' value='3' /> Partially Met
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Client Goal</span>
                    <textarea id='txt_17' name='txt_17' className='add-only'></textarea>
                </p>
                <h3>Short Term Objective(s) - Measurable and Indiviualized</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 1.1:</span>
                    <textarea id='txt_18' name='txt_18' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Status/ Progress Towards Objective:</span>
                    <textarea id='txt_18a' name='txt_18a' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Modifications </span><span className='small'>(If Applicable):</span>
                    <textarea id='txt_18b' name='txt_18b' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Target Date</span>
                            <input type='date' id='txt_19' name='txt_19' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 1.2:</span>
                    <textarea id='txt_20' name='txt_20' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Status/ Progress Towards Objective:</span>
                    <textarea id='txt_18c' name='txt_18c' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Modifications </span><span className='small'>(If Applicable):</span>
                    <textarea id='txt_18d' name='txt_18d' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Target Date</span>
                            <input type='date' id='txt_21' name='txt_21' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 1.3:</span>
                    <textarea id='txt_22' name='txt_22' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Status/ Progress Towards Objective:</span>
                    <textarea id='txt_18e' name='txt_18e' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Modifications </span><span className='small'>(If Applicable):</span>
                    <textarea id='txt_18f' name='txt_18f' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Target Date</span>
                            <input type='date' id='txt_23' name='txt_23' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Client Problem #2</span>
                    <textarea id='txt_24' name='txt_24' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rb_24_1' name='rb_24' className='add-only' value='1' /> New
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_24_2' name='rb_24' className='add-only' value='2' /> Fully Met
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_24_3' name='rb_24' className='add-only' value='3' /> Partially Met
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Client Goal:</span>
                    <textarea id='txt_25' name='txt_25' className='add-only'></textarea>
                </p>
                <h3>Short Term Objective(s) - Measurable and Indiviualized</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 2.1:</span>
                    <textarea id='txt_26' name='txt_26' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Status/ Progress Towards Objective:</span>
                    <textarea id='txt_261' name='txt_261' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Modifications </span><span className='small'>(If Applicable):</span>
                    <textarea id='txt_262' name='txt_262' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Target Date</span>
                            <input type='date' id='txt_27' name='txt_27' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 2.2:</span>
                    <textarea id='txt_28' name='txt_28' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Status/ Progress Towards Objective:</span>
                    <textarea id='txt_263' name='txt_263' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Modifications </span><span className='small'>(If Applicable):</span>
                    <textarea id='txt_264' name='txt_264' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Target Date</span>
                            <input type='date' id='txt_29' name='txt_29' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 2.3:</span>
                    <textarea id='txt_30' name='txt_30' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Status/ Progress Towards Objective:</span>
                    <textarea id='txt_265' name='txt_265' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Modifications </span><span className='small'>(If Applicable):</span>
                    <textarea id='txt_266' name='txt_266' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Target Date</span>
                            <input type='date' id='txt_31' name='txt_31' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Services</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Duration and Frequency</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Provider Name and Credentials</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_32' name='cb_32' className='add-only' value='1' /> Individual Therapy H2019 HR
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_33' name='txt_33' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_34' name='txt_34' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_35' name='cb_35' className='add-only' value='1' /> Group Therapy H2019 HQ
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_36' name='txt_36' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_37' name='txt_37' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_38' name='cb_38' className='add-only' value='1' /> TBOS - Therapy H2019 HO
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_39' name='txt_39' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_40' name='txt_40' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_41' name='cb_41' className='add-only' value='1' /> Medication Management T1015
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_42' name='txt_42' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_43' name='txt_43' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_44' name='cb_44' className='add-only' value='1' /> Medication Management T1015
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_45' name='txt_45' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_46' name='txt_46' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_47' name='cb_47' className='add-only' value='1' />  Psychosocial Rehabilitation Services
                            (CSC)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_48' name='txt_48' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_49' name='txt_49' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_53' name='cb_53' className='add-only' value='1' />  Treatment Plan Development H0032
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_54' name='txt_54' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_55' name='txt_55' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_56' name='cb_56' className='add-only' value='1' />
                            Treatment Plan Review H0032 TS
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_57' name='txt_57' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_58' name='txt_58' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_59' name='cb_59' className='add-only' value='1' />
                            Treatment Plan Addendum H0032 TSADD
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_60' name='txt_60' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_61' name='txt_61' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Assessments</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Name and Credentials</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cb_62' name='cb_62' className='add-only' value='1' />
                            Psychiatric Evaluation H2000 HP
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txt_64' name='txt_64' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cb_65' name='cb_65' className='add-only' value='1' />
                            Biopsychosocial Evaluation H0031 HN
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txt_67' name='txt_67' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cb_68' name='cb_68' className='add-only' value='1' />
                            Brief Behavioral Health Status
                            Examination H2010 HO
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txt_70' name='txt_70' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cb_71' name='cb_71' className='add-only' value='1' />
                            Limited Functional Assessment
                            CFARS/FARS H0031
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txt_73' name='txt_73' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Client Strengths</span>
                    <textarea id='txt_74' name='txt_74' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Client Needs</span>
                    <textarea id='txt_75' name='txt_75' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Client Abilities</span>
                    <textarea id='txt_76' name='txt_76' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Client Preferences</span>
                    <textarea id='txt_77' name='txt_77' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Client Limitations</span>
                    <span className='small'>(Barriers to Treatment)</span>
                    <textarea id='txt_78' name='txt_78' className='add-only'></textarea>
                </p>
                <h3>Psychiatric Services and Medication Management</h3>
                <p className='w-750'>
                    <span className='eleHeader'>1. Does client receive psychiatric and medication management services from Right
                        Path Behavioral Health Services?</span>
                    <textarea id='txt_79' name='txt_79' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>2. Does client receive psychiatric and medication management services from an
                        external provider?</span>
                    <textarea id='txt_80' name='txt_80' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>3. Is client currently prescribed medication from Right Path Behavioral Health
                        Services or an external provider? If yes, please list all medication names, dosages, and frequencies.</span>
                    <textarea id='txt_81' name='txt_81' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>4. Is prescribed medication effective? Does client report any side effects of the
                        prescribed medication(s)? </span>
                    <textarea id='txt_82' name='txt_82' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Treatment Plan Review Summary and Justification for Contiinued Services</span>
                    <textarea id='txt_83' name='txt_83' className='add-only'></textarea>
                </p>
                <h3>Status, Compliance, Changes in Treatment, Referrals, and Follow-Up</h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Clients Current Status </span><span className='small'>(please check one)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rb_84_1' name='rb_84' className='add-only' value='1' /> Stable
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rb_84_2' name='rb_84' className='add-only' value='2' /> Unstable
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rb_84_3' name='rb_84' className='add-only' value='3' /> Improving
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rb_84_4' name='rb_84' className='add-only' value='4' /> Worsening
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Clients Current Level of Progress in Service:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rb_85_1' name='rb_85' className='add-only' value='1' /> No Progress
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rb_85_2' name='rb_85' className='add-only' value='2' /> Mild Progress
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rb_85_3' name='rb_85' className='add-only' value='3' /> Moderate Progress
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rb_85_4' name='rb_85' className='add-only' value='4' /> Exceptional Progress
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Is Client Complying with Treatment Plan/Review/Addendum </span><span className='small'>(Please Check one)?:</span>
                            <input type='radio' id='rb_86_1' name='rb_86' className='add-only' value='1' />    Yes&nbsp;
                            <input type='radio' id='rb_86_2' name='rb_86' className='add-only' value='2' />      No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Description of Non-Compliance or Please Check if N/A:</span>
                    <input type='checkbox' id='cb_87' name='cb_87' className='add-only' value='1' /> N/A<br />
                    <textarea id='txt_88' name='txt_88' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Are Any Changes to Service Necessary</span><span className='small'> (please Check One)?</span>
                    <input type='radio' id='rb_89_1' name='rb_89' className='add-only' value='1' /> Yes&nbsp;
                    <input type='radio' id='rb_89_2' name='rb_89' className='add-only' value='2' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Description of Proposed changes or Please Check if N/A:</span>
                    <input type='checkbox' id='cb_90' name='cb_90' className='add-only' value='1' /> N/A<br />
                    <textarea id='txt_91' name='txt_91' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Refferals or Please Check if N/A:</span>
                    <input type='checkbox' id='cb_92' name='cb_92' className='add-only' value='1' /> N/A<br />
                    <textarea id='txt_93' name='txt_93' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Follow-up Recommended in:</span>
                    <input type='radio' id='rb_94_1' name='rb_94' className='add-only' value='1' /> 3 Months
                    <input type='radio' id='rb_94_2' name='rb_94' className='add-only' value='2' /> 6 Months
                    <input type='radio' id='rb_94_3' name='rb_94' className='add-only' value='3' />
                    <input type='text' id='txt_95_1' name='txt_95_1' className='add-only' />
                    Months
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>After-care plan</span> <span className='small'>(For TBOS Only)</span>
                    <span className='small'>Please provide details regarding any additional providers included in the provision of TBOS and the community
                        resources, activities, services, and supports that will be utilized to help the client to sustain gains achieved
                        during treatment.</span>
                    <textarea id='txt_95' name='txt_95' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Discharge Criteria </span><span className='small'>(Measurable and Indiviualized)</span>
                    <textarea id='txt_96' name='txt_96' className='add-only'></textarea>
                </p>
                <h3>Child/Adolescent Level of Care Worksheet
                </h3>
                <h4>Dimension
                </h4>
                <h4>I. Risk of Harm to Self and/or Others
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Rating</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSignificant1' name='cbSignificant1' className='add-only' value='1' /> 1. Minimal Risk of Harm
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSignificant2' name='cbSignificant2' className='add-only' value='1' /> 2. Some Risk of Harm
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSignificant3' name='cbSignificant3' className='add-only' value='1' /> 3. Significant Risk of Harm
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSignificant4' name='cbSignificant4' className='add-only' value='1' /> 4. Serious Risk of Harm
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSignificant5' name='cbSignificant5' className='add-only' value='1' /> 5. Extreme Risk of Harm
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Score</b>
                    <input type='text' id='txtScore122' name='txtScore122' className='add-only' />
                </p>
                <h4>Dimension
                </h4>
                <h4>II. Functional Status
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Rating</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMinimal17' name='cbMinimal17' className='add-only' value='1' /> 1. Minimal Imairment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMinimal27' name='cbMinimal27' className='add-only' value='1' /> 2. Mild Impairment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMinimal37' name='cbMinimal37' className='add-only' value='1' /> 3. Moderate Impairment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMinimal47' name='cbMinimal47' className='add-only' value='1' /> 4. Serious Impairment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMinimal57' name='cbMinimal57' className='add-only' value='1' /> 5. Severe Impairment
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Score</b>
                    <input type='text' id='txtScore1' name='txtScore1' className='add-only' />
                </p>
                <h4>Dimension
                </h4>
                <h4>III. Co-Morbidity
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Rating</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMinimal1' name='cbMinimal1' className='add-only' value='1' /> 1. No Co-Morbidity
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMinimal2' name='cbMinimal2' className='add-only' value='1' /> 2. Minor Co-Morbidity
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMinimal3' name='cbMinimal3' className='add-only' value='1' /> 3. Significant Co-Morbidity
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMinimal4' name='cbMinimal4' className='add-only' value='1' /> 4. Major Co-Morbidity
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMinimal5' name='cbMinimal5' className='add-only' value='1' /> 5. Severe Co-Morbidity
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Score</b>
                    <input type='text' id='txtScore2' name='txtScore2' className='add-only' />
                </p>
                <h4>Dimension
                </h4>
                <h4>IV - A. Recovery Environment - Environmental Stress
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Rating</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMinimal10' name='cbMinimal10' className='add-only' value='1' /> 1. Low Stress Environment
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMinimal20' name='cbMinimal20' className='add-only' value='1' /> 2. Mildly Stressful Environment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMinimal30' name='cbMinimal30' className='add-only' value='1' /> 3. Moderately Stressful Environment
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMinimal40' name='cbMinimal40' className='add-only' value='1' /> 4. Highly Stressful Environment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMinimal50' name='cbMinimal50' className='add-only' value='1' /> 5. Extremely Stressful Environment
                        </td>
                        <td className='w-375'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Score</b>
                    <input type='text' id='txtScore3' name='txtScore3' className='add-only' />
                </p>
                <h4>Dimension
                </h4>
                <h4>IV - B. Recovery Environment - Environmental Support
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Rating</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHighly141' name='cbHighly141' className='add-only' value='1' /> 1. Highly Supportive Environment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHighly241' name='cbHighly241' className='add-only' value='1' /> 2. Supportive Environment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHighly251' name='cbHighly251' className='add-only' value='1' /> 3. Limited Support in Environment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHighly261' name='cbHighly261' className='add-only' value='1' /> 4. Minimal Support in Environment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHighly271' name='cbHighly271' className='add-only' value='1' /> 5. No Support in Environment
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Score</b>
                    <input type='text' id='txtScore4' name='txtScore4' className='add-only' />
                </p>
                <h4>Dimension
                </h4>
                <h4>IV. Resiliency and Treatment History
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Rating</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFull22' name='cbFull22' className='add-only' value='1' /> 1. Full Resiliency and/or Response to Treatment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFull23' name='cbFull23' className='add-only' value='1' /> 2. Significant Resiliency and/or Response to Treatment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFull24' name='cbFull24' className='add-only' value='1' /> 3. Moderate Resiliency and/or Response to Treatment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFull25' name='cbFull25' className='add-only' value='1' /> 4. Poor Resiliency and/or Response to Treatment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFull26' name='cbFull26' className='add-only' value='1' /> 5. Negligible Resiliency and/or Response to Treatment
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Score</b>
                    <input type='text' id='txtScore5' name='txtScore5' className='add-only' />
                </p>
                <h4>Dimension
                </h4>
                <h4>VI-A. Acceptance and Engagement (Child/Adolescent)
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Rating</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOptimal' name='cbOptimal' className='add-only' value='1' /> 1. Optimal
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOptimal1' name='cbOptimal1' className='add-only' value='1' /> 2. Constructive
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOptimal2' name='cbOptimal2' className='add-only' value='1' /> 3. Obstructive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOptimal3' name='cbOptimal3' className='add-only' value='1' /> 4. Adversarial
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOptimal4' name='cbOptimal4' className='add-only' value='1' /> 5. Inaccessible
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Score</b>
                    <input type='text' id='txtScore6' name='txtScore6' className='add-only' />
                </p>
                <h4>Dimension
                </h4>
                <h4>VI-B. Acceptance and Engagement (Parent/Guardian)
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Rating</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbConstructive' name='cbConstructive' className='add-only' value='1' /> 1. Optimal
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbConstructive1' name='cbConstructive1' className='add-only' value='1' /> 2. Constructive
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbConstructive2' name='cbConstructive2' className='add-only' value='1' /> 3. Obstructive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbConstructive3' name='cbConstructive3' className='add-only' value='1' /> 4. Adversarial
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbConstructive4' name='cbConstructive4' className='add-only' value='1' /> 5. Inaccessible
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Score</b>
                    <input type='text' id='txtScore7' name='txtScore7' className='add-only' />
                </p>
                <h4>Dimension
                </h4>
                <h4>Level of Care Recommendation:<input type='text' id='txtScore8' name='txtScore8' className='add-only' />
                </h4>
                <p className='w-750'>
                    <b>Only include the higest scores on IV-A/IV-B and VI-A & VI-B in your composite score</b>
                </p>
                <p className='w-750'>
                    <b>Composite Score:</b>
                    <input type='text' id='txtScore9' name='txtScore9' className='add-only' />
                </p>
                <p className='w-750'>
                    Please note that the scores are the number indicated next to the rating (1 - 5)
                </p>
                <h3>Adult Level of Care Worksheet
                </h3>
                <h4>Dimension
                </h4>
                <h4>I. Risk of Harm to Self and/or Others
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Rating</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSerious5' name='cbSerious5' className='add-only' value='1' /> 1. Minimal Risk of Harm
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSerious4' name='cbSerious4' className='add-only' value='1' /> 2. Some Risk of Harm
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSerious3' name='cbSerious3' className='add-only' value='1' /> 3. Significant Risk of Harm
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSerious2' name='cbSerious2' className='add-only' value='1' /> 4. Serious Risk of Harm
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSerious1' name='cbSerious1' className='add-only' value='1' /> 5. Extreme Risk of Harm
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Score</b>
                    <input type='text' id='txtScore' name='txtScore' className='add-only' />
                </p>
                <h4>Dimension
                </h4>
                <h4>II. Functional Status
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Rating</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMinimal11' name='cbMinimal11' className='add-only' value='1' /> 1. Minimal Imairment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMinimal21' name='cbMinimal21' className='add-only' value='1' /> 2. Mild Impairment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMinimal31' name='cbMinimal31' className='add-only' value='1' /> 3. Moderate Impairment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMinimal41' name='cbMinimal41' className='add-only' value='1' /> 4. Serious Impairment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMinimal511' name='cbMinimal511' className='add-only' value='1' /> 5. Severe Impairment
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Score</b>
                    <input type='text' id='txtScore11' name='txtScore11' className='add-only' />
                </p>
                <h4>Dimension
                </h4>
                <h4>III. Co-Morbidity
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Rating</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMorbidity5' name='cbMorbidity5' className='add-only' value='1' /> 1. No Co-Morbidity
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMorbidity4' name='cbMorbidity4' className='add-only' value='1' /> 2. Minor Co-Morbidity
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMorbidity3' name='cbMorbidity3' className='add-only' value='1' /> 3. Significant Co-Morbidity
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMorbidity2' name='cbMorbidity2' className='add-only' value='1' /> 4. Major Co-Morbidity
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMorbidity1' name='cbMorbidity1' className='add-only' value='1' /> 5. Severe Co-Morbidity
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Score</b>
                    <input type='text' id='txtScore21' name='txtScore21' className='add-only' />
                </p>
                <h4>Dimension
                </h4>
                <h4>IV - A. Recovery Environment - Level of Stress
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Rating</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMinimal111' name='cbMinimal111' className='add-only' value='1' /> 1. Low Stress Environment
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMinimal211' name='cbMinimal211' className='add-only' value='1' /> 2. Mildly Stressful Environment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMinimal311' name='cbMinimal311' className='add-only' value='1' /> 3. Moderately Stressful Environment
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMinimal411' name='cbMinimal411' className='add-only' value='1' /> 4. Highly Stressful Environment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMinimal51' name='cbMinimal51' className='add-only' value='1' /> 5. Extremely Stressful Environment
                        </td>
                        <td className='w-375'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Score</b>
                    <input type='text' id='txtScore31' name='txtScore31' className='add-only' />
                </p>
                <h4>Dimension
                </h4>
                <h4>IV - B. Recovery Environment - Level of Support
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Rating</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHighly11' name='cbHighly11' className='add-only' value='1' /> 1. Highly Supportive Environment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHighly21' name='cbHighly21' className='add-only' value='1' /> 2. Supportive Environment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHighly22' name='cbHighly22' className='add-only' value='1' /> 3. Limited Support in Environment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHighly23' name='cbHighly23' className='add-only' value='1' /> 4. Minimal Support in Environment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHighly24' name='cbHighly24' className='add-only' value='1' /> 5. No Support in Environment
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Score</b>
                    <input type='text' id='txtScore41' name='txtScore41' className='add-only' />
                </p>
                <h4>Dimension
                </h4>
                <h4>V. Treatment and Recovery History
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Rating</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFull2' name='cbFull2' className='add-only' value='1' /> 1. Full Response to Treatment and Recovery Management
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFull3' name='cbFull3' className='add-only' value='1' /> 2. Significant Response to Treatment and Recovery Management
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFull4' name='cbFull4' className='add-only' value='1' /> 3. Moderate Response to Treatment and Recovery Management
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFull5' name='cbFull5' className='add-only' value='1' /> 4. Poor Response to Treatment and Recovery Management
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFull6' name='cbFull6' className='add-only' value='1' /> 5. Negligible Response to Treatment and Recovery Management
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Score</b>
                    <input type='text' id='txtScore51' name='txtScore51' className='add-only' />
                </p>
                <h4>Dimension
                </h4>
                <h4>VI. Engagement
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Rating</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOptimal211' name='cbOptimal211' className='add-only' value='1' /> 1. Optimal
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOptimal12' name='cbOptimal12' className='add-only' value='1' /> 2. Constructive
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOptimal22' name='cbOptimal22' className='add-only' value='1' /> 3. Obstructive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOptimal32' name='cbOptimal32' className='add-only' value='1' /> 4. Adversarial
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOptimal42' name='cbOptimal42' className='add-only' value='1' /> 5. Inaccessible
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Score</b>
                    <input type='text' id='txtScore61' name='txtScore61' className='add-only' />
                </p>
                <h4>Dimension
                </h4>
                <h4>Level of Care Recommendation:<input type='text' id='txtScore81' name='txtScore81' className='add-only' />
                </h4>
                <p className='w-750'>
                    <b>Only include the higest scores on IV-A/IV-B in your composite score</b>
                </p>
                <p className='w-750'>
                    <b>Composite Score:</b>
                    <input type='text' id='txtScore91' name='txtScore91' className='add-only' />
                </p>
                <p className='w-750'>
                    Please note the scores are the number indicated next to the rating (1 - 5)
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recommendations</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='rb_97_1' name='rb_97_1' className='add-only' value='1' />
                            Individual and Family Therapy
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cb_97_4' name='cb_97_4' className='add-only' value='4' /> Biopsychosocial Evaluation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='rb_97_2' name='rb_97_2' className='add-only' value='2' /> Therapeutic Behavioral On-Site Therapy (TBOS)
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cb_97_11' name='cb_97_11' className='add-only' value='11' />Medication Management
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cb_97_5' name='cb_97_5' className='add-only' value='5' />Limited Functional Assessment
                            (CFARS/FARS)
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cb_97_6' name='cb_97_6' className='add-only' value='6' />Treatment Plan
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cb_97_7' name='cb_97_7' className='add-only' value='7' />Treatment Plan Review
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cb_97_8' name='cb_97_8' className='add-only' value='8' />Treatment Plan Addendum
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cb_97_9' name='cb_97_9' className='add-only' value='9' />Brief Behavioral Health Status
                            Examination
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cb_97_10' name='cb_97_10' className='add-only' value='10' />Psychiatric Evaluation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cb_97_3' name='cb_97_3' className='add-only' value='3' /> Community Support
                            Services/Psychosocial Rehabilitation (PSR)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Expiration Date of Treatment Plan</span>
                            <input type='text' id='txt_98' name='txt_98' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    The services checked above are <b>medically necessary</b> and appropriate to the client's diagnosis, needs, and
                    transition/discontinuation of services.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Cooperative Treatment Planning:</span>
                    Signature below indicates that I/we have participated in the formulation of this treatment plan. Further, I
                    understand, approve, and accept the responsibilities(s) to fully carry out my part(s) of this treatment plan. In
                    addition, the services requested in the Treatment Plan are medically necessary and are the least restrictive for
                    the child's/ adolescent/ adult needs. Furthermore, I understand that Services are delivered utilizing a team
                    approach and are provided primarily to youth in their living arrangement and within the family system. Services
                    promote a family-based focus in order to: Defuse the current behavioral health crisis, evaluate its nature and
                    intervene to reduce the likelihood of a recurrence; Ensure linkage to needed community services and resources; and
                    Improve the individual child's/adolescent's ability to self-recognize and self-managed behavioral health issues, as
                    well as the parents's/responsible caregivers's capacity to care for their children.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is client unable to sign Treatment Plan/Review/Addendum?</span>
                    <span className='small'>If yes, please explain why client is unable to sign.</span>
                    <input type='radio' id='rb_99_Y' name='rb_99' value='Y' className='add-only' />
                    Yes&nbsp;
                    <input type='radio' id='rb_99_N' name='rb_99' value='N' className='add-only' />
                    No<br />
                    <textarea id='txt_99' name='txt_99' className='add-only'></textarea>
                </p>


                
            </div>
        </form>

    )
}











